<template>
    <div class="bg" :style="{
        'background': `url(${config.bgImageUrl}) no-repeat center/cover`,
        'backgroundColor': '#f5f5f5' // 添加备用背景色
    }">
        <!-- <img src="../assets/img/detailbj.png" alt="" class="bj"> -->

        <div class="con m_rl_20">
            <div>
                <img class="logo" :src="config.logoTopImg" alt="" :style="{ 'height': config.logoTopHeight + 'px' }">
                <img v-if="$i18n.locale == 'en'" src="../assets/img/jindutiao2.png" alt="" class="jindu">
                <img class="jindu" v-else src="../assets/img/jindutiao2_cn.png" alt="">
            </div>
            <div class="cont">
                <!-- <img src="../assets/img/back.png" alt="" class="back" @click="back"> -->
                <div class="imgs_wrap">
                    <div style="position:relative">
                        <img src="../assets/img/wei1.png" alt="" class="wei"
                            v-if="certificateDetail.operationName == 'Digital Life Design 2022'">
                        <img src="../assets/img/wei2.png" alt="" class="wei" v-else>
                        <span class="name">{{ certificateDetail.name }}</span>
                    </div>

                    <div class="description">
                        {{ $t('CarbonNeutralFor') }} <br>
                        {{ certificateDetail.operationName }}
                    </div>
                </div>

            </div>

            <div class="descript">
                <div class="descript_title">{{ $t('Description') }}</div>
                <ul>
                    <li>
                        <span>{{ $t('IssuedBy') }}</span>
                        <span class="span">MVGX</span>
                    </li>
                    <li>
                        <span>{{ $t('TokenStandard') }}</span>
                        <span class="span">ERC - 721</span>
                    </li>
                    <li>
                        <span>{{ $t('Blockchain') }}</span>
                        <span class="span">Ethereum</span>
                    </li>
                </ul>
            </div>
            <div class="tips">{{ $t('Youwillhavetheoption') }}</div>

            <div class="button_wrap">
                <div class="price">US$
                    <span>{{ formatStr(price, 2) }}</span>
                </div>
                <a :href="buyUrl">
                    <el-button class="bths" @click="orderDetail">{{ $t('PurchaseNow') }}</el-button>
                </a>
            </div>
        </div>

    </div>
</template>
<script>
import { formatStr } from '@/util/number.js'
import cnt from '@/api/cnt.js'
export default {
    data() {
        return {
            sn: '',
            price: '',
            certificateDetail: {},
            buyUrl: '',
            config: '',
        }
    },
    created() {
        this.sn = this.$route.query.sn;
        this.config = JSON.parse(sessionStorage.getItem('configData')) || ''
    },
    mounted() {
        this.sn = this.$route.query.sn
        this.getNftPrice()
        // this.getTravelRecord()
        this.getBuyUrl()
    },
    methods: {
        formatStr: formatStr,
        orderDetail() {
            localStorage.setItem('sn', this.sn)
            localStorage.setItem('price', this.price)
            // this.$router.push({ path: "/orderDetail", query: { sn: this.sn,price:this.price } });
        },
        back() {
            this.$router.go(-1)
        },
        getBuyUrl() {
            cnt.getBuyUrl(res => {
                console.log('res', res)
                this.buyUrl = res.buyUrl
            })
        },
        getNftPrice() {
            cnt.getNftPrice(res => {
                this.price = res.price
                console.log('res', res)
            })
        },
        getTravelRecord() {
            cnt.getTravelRecord(
                (res) => {
                    console.log('res.captureStatus', res)
                    // if (!res) {
                    //     this.$router.push({ path: "/result" });
                    // } else if (res.snStatus == 1) {
                    //     this.$router.push({ path: "/info", query: { sn: this.sn } });
                    // } else if (res.snStatus == null) {
                    //     if (res.operationName == null) {
                    //         this.$router.push({ path: "/welcome", query: { sn: this.sn } });
                    //     } else {
                    //         this.$router.push({ path: "/trip", query: { sn: this.sn } });
                    //     }
                    // }

                    if (res.captureStatus == 1) {
                        this.$router.push({ path: "/nftpay", query: { sn: this.sn } });
                    }

                    if (res.captureStatus == 2) {
                        this.$router.push({ path: "/success", query: { sn: this.sn } });
                    }
                    this.certificateDetail = res;
                },
                { sn: this.sn }
            );
        },
    }
}
</script>
<style lang="less" scoped>
.bg {
    width: 100%;
    min-height: 100%;
    background: url('../assets/img/bj.png') no-repeat;
    background-size: 100% 100%;
}

.tips {
    margin-top: 1.25rem;
    font-size: .75rem;
    color: #ffffff;
}

.bj {
    width: 100%;
    height: 15.5rem;
}

.logo {
    width: auto;
    position: absolute;
    top: 1.5rem;
    left: 1.25rem;
}

.con {
    // position: absolute;
    // top: 1.25rem;
    // position: absolute;
    // top: 1.25rem;
    padding: 1.25rem 0;
}

.jindu {
    width: 20.8438rem;
    height: 2.5938rem;
    position: absolute;
    top: 7rem;
    // left: 1.2813rem;
    left: auto;
    right: auto;
}

.cont {
    width: 100%;
    margin-top: 40px;

    .back {
        width: .8125rem;
        height: 1.375rem;
    }

    .imgs_wrap {
        margin-top: 1.3125rem;
        // width: 100%;
        padding: 1.25rem 1.25rem 1.8125rem;
        background: #ffffff;
        box-shadow: 0px .0625rem .75rem 0px rgba(15, 95, 75, 0.08);
        border-radius: 1.25rem;

        .wei {
            // width: 18.4375rem;
            // height: 18.4375rem;
            width: 100%;
            height: 100%;

        }

        .name {

            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }

        .description {
            margin-top: 1.25rem;
            font-size: 1rem;
            font-family: Arial-BoldMT, Arial;
            font-weight: bold;
            color: #303236;
            line-height: 1.25rem;
        }
    }

}

.descript {
    margin-top: 1.875rem;

    .descript_title {
        color: #ffffff;
        // color: #1E1E1E;
        font-weight: bold;
        font-size: 1.25rem;
        font-family: Arial-BoldMT, Arial;
        margin-bottom: 1.25rem;
    }

    ul {
        padding: 0 1.25rem 23px;
        background: #FFFFFF;
        box-shadow: 0px .0625rem .75rem 0px rgba(15, 95, 75, 0.08);
        border-radius: 1.25rem;

        li {
            height: 3.5rem;
            list-style: none;
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: .0625rem solid #E6F0F2;
            font-size: .9375rem;
            color: #303236;
            font-family: Century Gothic;

            .span {
                color: #8F8F8F;
            }
        }

    }
}

.button_wrap {
    margin: 2.375rem 0 1.875rem;
    height: 3.0625rem;
    background: #FFFFFF;
    box-shadow: 0px .0625rem .75rem 0px rgba(15, 95, 75, 0.08);
    border-radius: .625rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .price {
        font-size: .75rem;
        font-family: Gotham-Book, Gotham;
        font-weight: normal;
        color: #1E1E1E;
        margin-left: 1.4375rem;

        span {
            font-size: 1.25rem;
            font-family: Gotham-Bold, Gotham;
            font-weight: bold;
            color: #1E1E1E;
        }
    }

    a {
        width: 8.375rem;
        height: 100%;

        .bths {
            width: 8.375rem;
            height: 100%;
            background: linear-gradient(90deg, #6CB1CC 0%, #59C798 100%);
            box-shadow: 0px .1875rem .375rem 0px rgba(0, 98, 76, 0.22);
            border-radius: .625rem;
            color: #FFFFFF;
            font-size: .9375rem;
            font-weight: bold;
        }
    }

}

::v-deep .el-button {
    padding: 0;
}
</style>